exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#modal-planning .text-primary a span {\n\tcolor: #00a09c !important;\n}\n.modal-planning-description {\n\tbackground-color: #f3f4f5;\n\tpadding: 10px;\n\tborder-radius: 5px;\n\tborder: 1px solid #d5d6d6;\n\tcolor: #323635;\n\toverflow-y: hidden;\n\ttransition: height 0.5s;\n}\n.btn-modal-planning-see-more {\n\tborder-radius: 25px;\n\tborder: 1px solid #d5d6d6;\n\tpadding: 0 10px;\n}\n.height-150 {\n\theight: 150px;\n\ttransition: height 0.5s;\n}\n.height-auto {\n\theight: auto;\n\ttransition: height 0.5s;\n}\n", ""]);

// exports
